import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Cards from './Cards'
import Table from './Table'

import style from './style.sass'

@inject('store') @observer
class Pricing extends Component {
  render() {
    return(
      <div>
        <DocumentTitle title='Pricing'/>
        <div styleName='banner'/>
        <Cards/>
        <Table/>
      </div>
    )
  }
}

export default Pricing
